import React, { useState } from "react";
import "../Portfolio/Portfolio.css";

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const categories = [
    "All",
    "Coffee Plant",
    "Garden",
    "Office Plant",
    "Home Plant",
  ];
  const images = [
    {
      id: 1,
      src: "cp1.webp",
      title: "Coffee Plants",
      category: "Coffee Plant",
    },
    {
      id: 2,
      src: "cp2.webp",
      title: "Red Coffee Plant",
      category: "Coffee Plant",
    },
    {
      id: 3,
      src: "cp3.webp",
      title: "Red Coffee Plant",
      category: "Coffee Plant",
    },
    {
      id: 4,
      src: "cp4.webp",
      title: "Red Coffee Plant",
      category: "Coffee Plant",
    },
    { id: 5, src: "g1.webp", title: "Rustic Garden Bench", category: "Garden" },
    { id: 6, src: "g2.avif", title: "Red Verbena", category: "Garden" },
    { id: 7, src: "g3.avif", title: "Autumnal Flower", category: "Garden" },
    { id: 8, src: "g4.avif", title: "Adenium Obesum", category: "Garden" },
    {
      id: 9,
      src: "o1.webp",
      title: "Elegant Office Setup",
      category: "Office Plant",
    },
    {
      id: 10,
      src: "o2.webp",
      title: "Work Space Green Plant",
      category: "Office Plant",
    },
    {
      id: 11,
      src: "o3.avif",
      title: "Dracaena Fragrans Dragon Plant",
      category: "Office Plant",
    },
    { id: 12, src: "o4.webp", title: "Money Plant", category: "Office Plant" },
    {
      id: 13,
      src: "h1.avif",
      title: "Sansevieria Arabica",
      category: "Home Plant",
    },
    { id: 14, src: "h2.webp", title: "Indoor Plant", category: "Home Plant" },
    {
      id: 15,
      src: "h3.webp",
      title: "Monstera Deliciosa",
      category: "Home Plant",
    },
    { id: 16, src: "h4.avif", title: "Palm Tree", category: "Home Plant" },
  ];

  const filteredImages =
    activeCategory === "All"
      ? images
      : images.filter((image) => image.category === activeCategory);

  return (
    <div className="portfolio-section">
      <h2 className="portfolio-heading">Our Green Collections</h2>
      <p className="portfolio-description">
        Discover our curated collection of nursery designs, featuring beautiful
        gardens, cozy spaces, and creative ideas to inspire your green haven.
      </p>

      <div className="portfolio-buttons">
        {categories.map((category, index) => (
          <button
            key={index}
            className={`portfolio-button ${activeCategory === category ? "active" : ""}`}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>
      <div className="portfolio-grid">
        {filteredImages.map((image) => (
          <div className="portfolio-card" key={image.id}>
            <img
              src={image.src}
              alt={image.title}
              className="portfolio-image"
            />
            <div className="overlay-p">
              <p className="overlay-text-p">{image.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
